function TheGame() {
    /*////////////////////////////////////////////////////////////////////////////////
//standard game logic
     */
    this.gameId = _ndok_app_id;
    this.backgroundcolor = 0x9c96a0;
    this.positionGameItems = positionGameItems;
    this.initGame = initGame;
    this.resetGame = resetGame;
    this.stopGame = stopGame;
    this.startGame = startGame;
    this.cycleGame = cycleGame;
    var gameData = {};
    this.gameData = gameData;
    var sprites;

    var counter;

    var itemsPositionsObject = { b_9: { x: 618, y: 385, w: 34, h: 163, n: "b_9" }, b_8: { x: 583, y: 375, w: 34, h: 163, n: "b_8" }, b_7: { x: 547, y: 360, w: 34, h: 163, n: "b_7" }, b_6: { x: 511, y: 344, w: 34, h: 163, n: "b_6" }, b_5: { x: 475, y: 333, w: 34, h: 163, n: "b_5" }, b_4: { x: 618, y: 191, w: 34, h: 163, n: "b_4" }, b_3: { x: 583, y: 181, w: 34, h: 163, n: "b_3" }, b_2: { x: 547, y: 166, w: 34, h: 163, n: "b_2" }, b_1: { x: 511, y: 150, w: 34, h: 163, n: "b_1" }, b_0: { x: 475, y: 139, w: 34, h: 163, n: "b_0" }, s_02_9: { x: 365, y: 308, w: 39, h: 40, n: "s_02_9" }, s_02_8: { x: 322, y: 308, w: 39, h: 40, n: "s_02_8" }, s_02_7: { x: 279, y: 308, w: 39, h: 40, n: "s_02_7" }, s_02_6: { x: 236, y: 308, w: 39, h: 40, n: "s_02_6" }, s_02_5: { x: 193, y: 308, w: 39, h: 40, n: "s_02_5" }, s_02_4: { x: 150, y: 308, w: 39, h: 40, n: "s_02_4" }, s_02_3: { x: 107, y: 308, w: 39, h: 40, n: "s_02_3" }, s_02_2: { x: 64, y: 308, w: 39, h: 40, n: "s_02_2" }, s_02_1: { x: 21, y: 308, w: 39, h: 40, n: "s_02_1" }, scaffale_03: { x: 455, y: 0, w: 328, h: 600, n: "scaffale_03" }, g_02: { x: 10, y: 180, w: 404, h: 230, n: "g_02" }, s_03_12: { x: 343, y: 360, w: 39, h: 40, n: "s_03_12" }, s_03_11: { x: 300, y: 360, w: 39, h: 40, n: "s_03_11" }, s_03_10: { x: 258, y: 360, w: 39, h: 40, n: "s_03_10" }, s_03_9: { x: 172, y: 360, w: 39, h: 40, n: "s_03_9" }, s_03_8: { x: 86, y: 361, w: 39, h: 40, n: "s_03_8 " }, s_03_7: { x: 323, y: 308, w: 39, h: 40, n: "s_03_7" }, s_03_6: { x: 280, y: 308, w: 39, h: 40, n: "s_03_6" }, s_03_5: { x: 237, y: 308, w: 39, h: 40, n: "s_03_5" }, s_03_4: { x: 194, y: 308, w: 39, h: 40, n: "s_03_4" }, s_03_3: { x: 151, y: 308, w: 39, h: 40, n: "s_03_3" }, s_03_2: { x: 64, y: 308, w: 39, h: 40, n: "s_03_2" }, s_03_1: { x: 21, y: 308, w: 39, h: 40, n: "s_03_1" }, scaffale_02: { x: 455, y: 0, w: 328, h: 600, n: "scaffale_02" }, g_03: { x: 10, y: 180, w: 404, h: 230, n: "g_03" }, s_01_15: { x: 301, y: 360, w: 39, h: 40, n: "s_01_15" }, s_01_14: { x: 258, y: 360, w: 39, h: 40, n: "s_01_14" }, s_01_13: { x: 215, y: 360, w: 39, h: 40, n: "s_01_13" }, s_01_12: { x: 173, y: 360, w: 39, h: 40, n: "s_01_12" }, s_01_11: { x: 129, y: 360, w: 39, h: 40, n: "s_01_11" }, s_01_10: { x: 86, y: 361, w: 39, h: 40, n: "s_01_10" }, s_01_9: { x: 365, y: 307, w: 39, h: 40, n: "s_01_9" }, s_01_8: { x: 322, y: 308, w: 39, h: 40, n: "s_01_8" }, s_01_7: { x: 279, y: 308, w: 39, h: 40, n: "s_01_7" }, s_01_6: { x: 236, y: 308, w: 39, h: 40, n: "s_01_6" }, s_01_5: { x: 193, y: 308, w: 39, h: 40, n: "s_01_5" }, s_01_4: { x: 150, y: 308, w: 39, h: 40, n: "s_01_4" }, s_01_3: { x: 107, y: 308, w: 39, h: 40, n: "s_01_3" }, s_01_2: { x: 64, y: 308, w: 39, h: 40, n: "s_01_2" }, s_01_1: { x: 21, y: 308, w: 39, h: 40, n: "s_01_1" }, scaffale_01: { x: 455, y: 0, w: 328, h: 600, n: "scaffale_01" }, g_01: { x: 10, y: 180, w: 404, h: 230, n: "g_01" } };
    var gameScene;



    /**
     * CORE GAME LOGIC
     */
    function initGame() {
        sprites = game.sprites;

        positionGameItems();

        makeScenes();
        makeCounter();
        document.addEventListener(GameEvents.ANSWER_OK, onAnswerOk, true);
        document.addEventListener(GameEvents.ANSWER_WRONG, onAnswerWrong, true);
        document.addEventListener(GameEvents.EVENT_START_GAME, onStartGame, true);

    }



    function resetGame() {
        resetItems();
        prepareData();
    }

    function startGame() {

        scenesContainer.removeChildren(0, scenesContainer.children.length);
        scenesContainer.addChild(gameData.scene.container);
        counter.setText(gameData.currentItem + "/" + gameData.numItems);
        cycleGame();
    }

    function onStartGame() {

    }

    function cycleGame() {

        if (gameData.currentItem < gameData.numItems) {
            renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        } else {

            setTimeout(end, 800);
        }

    }

    function end() {
        stopGame();
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_END_GAME));
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        loopSequence = [renderOnce];
    }

    function stopGame() {
        gameData.scene.clear();
    }

    function prepareData() {

        gameData.numItems = 1;
        gameData.currentItem = 0;
        gameData.scene = gameScene;
        gameData.scene.reset();
    }


    function makeScenes() {
        scenesContainer = new Container();
        scenesContainer.position.set(334, 0);
        game.gameContainer.addChild(scenesContainer);

        gameScene = new Scene('biblio2', itemsPositionsObject);

    }

    function makeCounter() {
        counter = new ItemsCounter();
        game.gameContainer.addChild(counter.container);
    }


    function positionGameItems() {
        sprites.btn_gioca.x = 509;
        sprites.btn_gioca.y = 476;
        sprites.btn_gioca.alpha = 0;
    }

    function resetItems() {

    }

    /**
     * GAME LOGIC
     */
    function onAnswerOk(e) {
        renderer.view.dispatchEvent(new Event(GameEvents.GREEN_LIGHT));
        gameData.currentItem++;
        counter.setText(gameData.currentItem + "/" + gameData.numItems);

    }

    function onAnswerWrong(e) {
        renderer.view.dispatchEvent(new Event(GameEvents.RED_LIGHT));
    }
}

function Scene(sceneName, positions) {
    var name = sceneName;
    this.name = name;
    this.reset = reset;
    this.clear = clear;
    var animating;
    var currentState;
    this.setState = setState;

    //
    var tl = new TimelineMax();
    //
    var container = new Container();
    this.container = container;
    var buttonsContainer = new Container();
    var cursorIndex = 0;

    container.addChild(buttonsContainer);
    buttonsContainer.interactive = true;
    buttonsContainer.on('pointertap', onClick);

    renderer.view.addEventListener(GameEvents.EVENT_CYCLE_GAME, cycled);

    var sceneElements = {};
    var scaffoldsNames = ['01', '02', '03'];
    var currentScaffoldName;
    var answers = {
        '01': { charmap: 'mfcgiopera', answer: 'pifferaiomagico', },
        '02': { charmap: 'plaenuofci', answer: 'pollicino' },
        '03': { charmap: 'plaenuopcv', answer: 'lavolpeeluva' }
    };

    var maxChars = 0;





    initScene();

    function initScene() {
        var i;
        var itemName;
        var spriteItem;
        var pos;

        var graphics;

        for (i = 0; i < scaffoldsNames.length; i++) {
            itemName = scaffoldsNames[i];
            spriteItem = game.sprites['scaffale_' + itemName];
            pos = positions["scaffale_" + itemName];
            spriteItem.position.set(pos.x, pos.y);
            container.addChild(spriteItem);
            sceneElements["scaffale_" + itemName] = spriteItem;

            spriteItem = game.sprites['griglia_' + itemName];
            pos = positions["g_" + itemName];
            spriteItem.position.set(pos.x, pos.y);
            container.addChild(spriteItem);
            sceneElements["g_" + itemName] = spriteItem;
            maxChars = Math.max(maxChars, answers[itemName].answer.length);

        }
        for (i = 0; i < maxChars; i++) {
            graphics = new Graphics();

            graphics.beginFill(0xFFFFFF);
            graphics.lineStyle(0, 0xFFFFFF);
            graphics.drawRect(0, 0, 38, 38);
            graphics.endFill();
            container.addChild(graphics);
            sceneElements['s_' + i] = graphics;
        }
        for (i = 0; i < 10; i++) {
            graphics = new Graphics();
            pos = positions['b_' + i];
            graphics.beginFill(0xFF0000);
            graphics.lineStyle(1, 0xFFFFFF);
            graphics.drawRect(0, 0, pos.w, pos.h);
            graphics.endFill();
            graphics.position.set(pos.x, pos.y);

            graphics.interactive = true;
            graphics.buttonMode = true;
            buttonsContainer.addChild(graphics);
            sceneElements['b_' + i] = graphics;
            // graphics.alpha = 0;
        }
    }


    function clear() {


    }

    function reset() {
        scaffoldsNames = _.shuffle(scaffoldsNames);
        setState('newScaffold');
    }

    function resetScaffolds() {
        var i;

        for (i = 0; i < scaffoldsNames.length; i++) {
            itemName = scaffoldsNames[i];
            var isCurrent = itemName === currentScaffoldName;
            sceneElements["scaffale_" + itemName].visible = isCurrent;
            sceneElements["g_" + itemName].visible = isCurrent;
        }
        var nChars = answers[currentScaffoldName].answer.length;
        for (i = 0; i < maxChars; i++) {
            var elementName = 's_' + i;

            sceneElements[elementName].visible = i < nChars;
            sceneElements[elementName].alpha = 1;
            if (i < nChars) {
                var posObjName = 's_' + currentScaffoldName + '_' + (i + 1);
                var pos = positions[posObjName];

                sceneElements[elementName].position.set(pos.x, pos.y);
            }
        }
        theGame.gameData.numItems = answers[currentScaffoldName].answer.length;
    }

    function cycled() {
        setState('ready');
    }

    function setState(state) {

        switch (state) {
            case 'newScaffold':


                scaffoldsNames.push(scaffoldsNames.shift());

                currentScaffoldName = scaffoldsNames[0];

                cursorIndex = 0;
                resetScaffolds();


                break;
            case 'ready':

                break;
            case 'animating':


                break;
        }
        currentState = state;

    }

    function onClick(e) {
        var i;
        var pos;
        if (currentState === "ready") {

            var bookNum = -1;
            for (i = 0; i < 10; i++) {
                if (sceneElements['b_' + i] === e.target) {

                    bookNum = i;
                }
            }

            if (bookNum < 0) {
                return false;
            }

            var bookChar = answers[currentScaffoldName].charmap[bookNum];
            var ok = bookChar === answers[currentScaffoldName].answer[cursorIndex];


            if (ok) {
                setState('animating');
                renderer.view.dispatchEvent(new Event('answerOk'));
                tl.to(sceneElements['s_' + cursorIndex], 0.75, {
                    pixi: { alpha: 0 }
                }).addCallback(okComplete);
                loopSequence = [renderAlways];

            } else {
                setState('animating');
                renderer.view.dispatchEvent(new Event('answerWrong'));
                setTimeout(wrongComplete, 1000);
                loopSequence = [renderOnce];
            }


        }

    }

    function okComplete() {
        sceneElements['s_' + cursorIndex].visible = false;

        cursorIndex++;
        if (cursorIndex < answers[currentScaffoldName].answer.length) {
            setState('ready');
        }

        theGame.cycleGame();
        loopSequence = [renderOnce];


    }

    function wrongComplete() {
        theGame.cycleGame();
        loopSequence = [renderOnce];
        setState('ready');
    }
}